import { Metamodel } from 'app/model/base/model';
import { TabularTypeSettings } from './tabular-type-settings';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { DataFlowExpression } from '../dataflowexpression';
import { DataFlowSource, IsolationLevel } from '../dataflow-source';
import { IntegerDataFlowType, StringDataFlowType } from '../dataflow-datatype';
import { AzurePostgreSqlTableDataset } from 'app/model/dataset/azure-postgre-sql-table.dataset';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.azurePostgreSQL.dataflowSettings
})
export class PostgreSqlSettings extends TabularTypeSettings {
    public isolationLevel: DataFlowExpression;
    public isPreSqlsListOfExpression: boolean;
    public preSqls: DataFlowExpression[];
    public isPostSqlsListOfExpression: boolean;
    public postSqls: DataFlowExpression[];

    public supportDataFlowStoreProcedure: boolean = true;

    @Metamodel.attribute({
        constraint: {
            validator: DataFlowSource.validateBatchSize
        }
    })
    public batchSize: DataFlowExpression;

    public initialize(subFormat: string): void {
        super.initialize(subFormat);
        this.isolationLevel = this.transform.createTemplatableExpression(StringDataFlowType.TYPE, IsolationLevel.ReadUncommitted);
        this.batchSize = this.transform.createTemplatableExpression(IntegerDataFlowType.TYPE);
        this.isPreSqlsListOfExpression = true;
        this.isPostSqlsListOfExpression = true;
        this.preSqls = [this.transform.createTemplatableExpression()];
        this.postSqls = [this.transform.createTemplatableExpression()];
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.PostgreSql;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getDatasetType(): string {
        return Metamodel.modelFor(AzurePostgreSqlTableDataset).name;
    }

    public getIconClass(): string {
        return 'i-100x100-azure_postgreSQL';
    }
}
